// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"LoadMoreLoader_loadingWrap__ZZCpW","dotsAnim":"LoadMoreLoader_dotsAnim__2DQet","wave":"LoadMoreLoader_wave__3rFj-"};